import * as React from "react";
import { Outlet } from "react-router-dom";

function Home() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Home;
